import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const CancelAgreementIllustration = ({
  width = 160,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg viewBox="0 0 372 400" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path id="ix8lc406ba" d="M0 0h89.09v89.092H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#DADADA" d="M257.125 60 52 90.386 88.686 340l205.126-30.38z" />
        <path fill="#FFF" d="M69.497 325.682h206.819V74.32H69.497z" />
        <path d="M67.907 327.273h210V72.728h-210v254.545zm3.181-3.181h203.637V75.91H71.088v248.182z" fill="#C6C6C6" />
        <path
          d="M109.27 187.273h127.273v-19.09H109.27v19.09zm0 44.546h127.273v-19.091H109.27v19.09zm0 44.545h95.187v-19.09H109.27v19.09z"
          fill="#878787"
        />
        <path fill="#00396C" d="M109.27 130h76.364v-19.09H109.27z" />
        <g transform="translate(230.182 250.91)">
          <mask id="bv6crto9jb" fill="#fff">
            <use xlinkHref="#ix8lc406ba" />
          </mask>
          <path
            d="M89.09 44.546c0 24.6-19.945 44.546-44.545 44.546S-.001 69.146-.001 44.546C-.001 19.946 19.945 0 44.545 0c24.6 0 44.546 19.946 44.546 44.546"
            fill="#AD0016"
            mask="url(#bv6crto9jb)"
          />
        </g>
        <path
          d="m283.463 295.457 8.746-8.746a6.172 6.172 0 0 0 .006-8.734 6.174 6.174 0 0 0-8.74 0l-8.746 8.74-8.746-8.746a6.178 6.178 0 0 0-8.734 0 6.167 6.167 0 0 0 0 8.734l8.74 8.746-8.746 8.746a6.174 6.174 0 0 0 0 8.74 6.178 6.178 0 0 0 8.734 0l8.746-8.746 8.746 8.746a6.18 6.18 0 0 0 8.74.006 6.185 6.185 0 0 0 0-8.74l-8.746-8.746z"
          fill="#FFF"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
